import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class AddressFieldHandler {
  productType: ProductType;
  clientWithoutAddressAllowed: boolean; //Config-Value von 'client.personWithoutAddressAllowed'

  setProductType(type: ProductType) {
    this.productType = type;
  }

  setClientWithoutAddressAllowed(value: boolean) {
    this.clientWithoutAddressAllowed = value;
  }

  /**
   * Überprüft, ob bestimmtes Adress-Formular-Feld erforderlich ist:
   * Kundenspezifische Konfigurationen können mithilfe von {@link CustomAddressConfigHolder} übergeben werden.
   */
  isRequired(fieldName: AddressFormularField, customConfig?: CustomAddressConfigHolder): boolean {
    const requiredForDigital = [AddressFormularField.FIRST_NAME, AddressFormularField.LAST_NAME, AddressFormularField.EMAIL, AddressFormularField.SALUTATION];

    const requiredForPrint = [AddressFormularField.FIRST_NAME, AddressFormularField.SALUTATION, AddressFormularField.LAST_NAME,
      AddressFormularField.STREET, AddressFormularField.HOUSE_NUMBER, AddressFormularField.COUNTRY,
      AddressFormularField.ZIPCODE, AddressFormularField.CITY];

    if (customConfig && customConfig.birthdayRequired) {
      requiredForPrint.push(AddressFormularField.BIRTHDAY);
      requiredForDigital.push(AddressFormularField.BIRTHDAY);
    }

    if (customConfig && customConfig.phoneRequired) {
      requiredForPrint.push(AddressFormularField.PHONE);
      // PHONE, nicht PHONE_CODE: für PHONE_CODE gibt es weder Formular-Control noch Feld
      requiredForDigital.push(AddressFormularField.PHONE);
    }

    const requiredSet = (this.productType === 'digital' && this.clientWithoutAddressAllowed) ? requiredForDigital : requiredForPrint;

    return requiredSet.includes(fieldName);
  }

  reset() {
    if (this.productType) {
      this.setProductType(null);
    }

    if (this.clientWithoutAddressAllowed) {
      this.setClientWithoutAddressAllowed(null);
    }
  }
}

/**
 * Hält kundenspezifische Konfigurationen:
 * - offer.askForBirthday
 * - offer.askForPhone
 * für ihre spätere Auswertung.
 **/
export class CustomAddressConfigHolder {
  birthdayRequired: boolean;
  phoneRequired: boolean;
  emailRequired: boolean;

  constructor() {
  }

  setBirthdayRequired(birthdayRequired: boolean) {
    this.birthdayRequired = birthdayRequired;
  }

  setPhoneRequired(phoneRequired: boolean) {
    this.phoneRequired = phoneRequired;
  }

  setEmailRequired(emailRequired: boolean) {
    this.emailRequired = emailRequired;
  }
}

export enum AddressFormularField {
  SALUTATION = 'salutation',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  STREET = 'street',
  HOUSE_NUMBER = 'houseNumber',
  COUNTRY = 'country',
  ZIPCODE = 'zipcode',
  CITY = 'city',
  BIRTHDAY = 'birthday',
  EMAIL = 'email',
  PHONE = 'phone',
  PHONE_CODE = 'phoneCode'
}

export type ProductType = 'digital' | 'print';
